export enum Scope {
   Create = 'create',
   Delete = 'delete',
   Update = 'update',
   View = 'view',
}

export enum ScopeType {
   Tenants = 'tenants',
   Teams = 'teams',
   Users = 'users',
   InternalJobFunctions = 'internal_job_functions',
   JobFunctions = 'job_functions',
   Clusters = 'clusters',
   Employers = 'employers',
   Companies = 'companies',
}

export interface AllowedScopes {
   clusters: Array<Scope>;
   employers: Array<Scope>;
   internal_job_functions: Array<Scope>;
   job_functions: Array<Scope>;
   teams: Array<Scope>;
   tenants: Array<Scope>;
   users: Array<Scope>;
   companies: Array<Scope>;
}
